import clsx from 'clsx';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import {
  selectCampaignCadencesCampaigns,
  selectCampaignCadencesSelectedCampaignId,
} from '../../../../features/campaign-cadences/store/campaignCadencesSlice';
import styles from './CampaignsSidebar.module.css';

export const CampaignsSidebar = forwardRef(function CampaignsSidebar(
  { className = '', style, onSelect },
  ref,
) {
  const campaigns = useSelector(selectCampaignCadencesCampaigns);
  const selectedId = useSelector(selectCampaignCadencesSelectedCampaignId);

  return (
    <aside ref={ref} className={clsx(styles.sidebar, className)} style={style}>
      <ul className={clsx(styles.list)} role="listbox" aria-label="Campaigns">
        {campaigns.map((at) => (
          <li key={at.id}>
            <button
              type="button"
              role="option"
              aria-selected={at.id === selectedId}
              className={clsx(styles.item, at.id === selectedId && styles.itemActive)}
              onClick={() => onSelect(at.id)}
            >
              {at.name}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
});
